import React, { Suspense } from 'react';

import { useConfig } from '../ConfigurationProvider';

const ProductFruitsMetric = React.lazy(() => import('./ProductFruitsMetric'));
const SmartlookMetric = React.lazy(() => import('./SmartlookMetric'));

export const Metrics = () => {
  const { deploymentType, metrics } = useConfig();

  return deploymentType === 'cloud' ? (
    <>
      <Suspense>{metrics.productFruitsCode && <ProductFruitsMetric code={metrics.productFruitsCode} />}</Suspense>
      <Suspense>{metrics.smartlookCode && <SmartlookMetric code={metrics.smartlookCode} />}</Suspense>
    </>
  ) : null;
};
